/** Company roles that get the dashboard. Matches the sections the server sends (backend analytics/overview.py ALL_ROLES). */
export const DASHBOARD_ROLES = ['COMPANY_ADMIN', 'OPERATIONS_MANAGER', 'DISPATCHER', 'FLEET_MANAGER', 'FINANCE_OFFICER', 'HR_OFFICER']

/** The first page a company user sees after signing in. */
export function landingPath(role: string | undefined): string {
  if (role === 'MUNICIPALITY_ADMIN') return '/municipality'
  if (role && DASHBOARD_ROLES.includes(role)) return '/tenant/dashboard'
  if (role === 'OWNER') return '/tenant/my-earnings'
  // A custom role: the portal's home picks the first page that role may open.
  if (role === 'COMPANY_STAFF') return '/tenant'
  return '/tenant/live-tracking'
}
